import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CommerceFilesChangeFileRequest } from '../_models/commerce-files-change-file-request.model';
import { CommerceFiles } from '../_models/commerce-files.model'
import { Observable} from 'rxjs';
import { environment } from 'src/environments/environment';
import { RestRoutes } from '../_config/rest-routes.config';
import { CommerceFilesCreate } from '../_models/commerce-files-create.model';
import { PaginatedList } from '../_models/PaginatedList.model';
import { CommerceFilesUpdate } from '../_models/commerce-files-update.model';


@Injectable({
  providedIn: 'root'
})
export class CommerceFilesService {

  httpOptions = {
    headers: new HttpHeaders(
      {
        'Content-Type': 'application/json'
      }
    ),
    //responseType: 'blob' as 'json'
};
constructor(private http: HttpClient) { }

  changeFile(commerceFileID: number, params: CommerceFilesChangeFileRequest): Observable<any> {
    const url = `${environment.urlWS}${RestRoutes.COMMERCEFILES_CHANGEFILE}${commerceFileID}/change-file/`;
    return this.http.post<any>(url, params, this.httpOptions);
  }

  createFile(params: CommerceFilesCreate): Observable<any> {
    const url = `${environment.urlWS}${RestRoutes.COMMERCE_FILES_POST}`;
    return this.http.post<any>(url, params, this.httpOptions);
  }

  getOne(commerceFileID: number): Observable<CommerceFiles> {
    const url = `${environment.urlWS}${RestRoutes.COMMERCE_FILES_GET}${commerceFileID}`;
    return this.http.get<CommerceFiles>(url, this.httpOptions);
  }

  // getFileBytes(commerceFileID: number): Observable<Blob> {
  //   const urlgetFileBytes = `${environment.urlWS}${RestRoutes.COMMERCE_FILES_DOWNLOAD}/get-bytes/${commerceFileID}`;
  //   return this.http.get<Blob>(urlgetFileBytes, { ...this.httpOptions,  responseType: 'blob' as 'json' });
  // }

  getVersions(commerceFileID: number): Observable<PaginatedList<CommerceFiles>> {
    const url = `${environment.urlWS}${RestRoutes.COMMERCE_FILES}/${commerceFileID}/versiones`;
    // console.log(url);
    return this.http.get<PaginatedList<CommerceFiles>>(url, this.httpOptions);
  }

  getAll(documentType?: string, contactIdGuid?: string): Observable<CommerceFiles[]> {
    let url = `${environment.urlWS}${RestRoutes.COMMERCE_FILES_GET}`;
    if(documentType != null && contactIdGuid == null){
      // console.log(1)
      url += `?documentType=${documentType}`;
    }
    if(contactIdGuid != null && documentType == null){
      // console.log(2)
      url += `?contactIdGuid=${contactIdGuid}`;
    }
    if(contactIdGuid != null && documentType != null){
      // console.log(3)
      url += `?documentType=${documentType}&contactIdGuid=${contactIdGuid}`;
    }
    // console.log(url)
    return this.http.get<CommerceFiles[]>(url, this.httpOptions);
  }

  delete(commerceFileID: number): Observable<boolean> {
    const url = `${environment.urlWS}${RestRoutes.COMMERCE_FILES_GET}/${commerceFileID}`;
    return this.http.delete<boolean>(url, this.httpOptions);
  }

  //Metodo Final cuando el endpoint esté listo /api/CommerceFilesHistoric/{commerceFilesHistoricID}/download

  getFileHistoricBytes(commerceFileHistoricID: number): Observable<Blob> {
    const urlgetFileHistoricBytes = `${environment.urlWS}${RestRoutes.COMMERCE_FILES_HISTORIC}/${commerceFileHistoricID}/download`;
    return this.http.get<Blob>(urlgetFileHistoricBytes, { ...this.httpOptions,  responseType: 'blob' as 'json' });
  }

  update(commerceFileId:number, params: CommerceFilesUpdate): Observable<CommerceFiles[]> {
    let urlAddUpdate: string = `${environment.urlWS}${RestRoutes.COMMERCE_FILES_POST}/${commerceFileId}`;
    return this.http.put<CommerceFiles[]>( urlAddUpdate, params, this.httpOptions);
  }

  GetDocumentType(): Observable<any> {
    const url = `${environment.urlWS}${RestRoutes.COMMERCE_FILES_TYPES_GET}`;
    return this.http.get<any>(url, this.httpOptions);
  }
}
